export const PREFILL_SOURCE = {
  QUERY: "query"
};

export const PREFILL_SOURCE_OPTIONS = [
  {
    id: PREFILL_SOURCE.QUERY,
    label: "Query",
    description: "Use query string params to prefill the field."
  }
];

export const PREFILL_DEFAULT = {
  enabled: true,
  source: PREFILL_SOURCE.QUERY,
  readonly: true,
  query: {
    keys: null
  }
};

export const RESERVED_PREFILL_QUERY_KEYS = {
  session: true,
  recovery: true,
  prefill: true
};
